export default function MacysLogo() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" id="macys">
      <path
        fill="#DB192A"
        d="m7.445 14.704-2.819 8.767L12 18.049l7.422 5.451-2.835-8.807L24 9.261h-9.162L12.015.5 9.19 9.262H0z"
      ></path>
    </svg>
  );
}
